var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { getSpaStore } from "../spaStore";
import { getStorage } from "./storage";
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["zh-CN"] = "zh-CN";
    LanguageCode["en"] = "en";
    LanguageCode["vi"] = "vi";
})(LanguageCode || (LanguageCode = {}));
/** @deprecated 配置请在项目中使用 */
export var languageConfig = [
    {
        text: "简体中文",
        value: LanguageCode["zh-CN"],
    },
    {
        text: "English",
        value: LanguageCode["en"],
    },
];
/** 支持的 i18n 语言，以及如果未找到对应语言设置的默认语言 */
export var i18nConfig = {
    defaultLang: LanguageCode["zh-CN"],
    langs: (_a = {},
        /** 简体中文 */
        _a[LanguageCode["zh-CN"]] = true,
        _a),
};
/**
 * i18n 类
 */
var I18ner = /** @class */ (function () {
    function I18ner(data) {
        var _this = this;
        /** 设置默认语言 */
        this.setLanguageCode = function (languageCode, emit) {
            if (emit === void 0) { emit = true; }
            _this.languageCode = _this.getLanguage(languageCode);
            getStorage().setItem("__language__", languageCode);
            if (emit) {
                getSpaStore().emit("change-language", languageCode);
            }
            getSpaStore().setState({ language: languageCode });
        };
        /** 获取当前语言 */
        this.getLanguageCode = function () {
            return _this.languageCode;
        };
        this.getBrowserLanguageCode = function () {
            var language = getStorage().getItem("__language__") ||
                (navigator.languages && navigator.languages[0]) ||
                navigator.language;
            return _this.getLanguage(language);
        };
        /**
         * 获取 i18n 数据
         */
        this.getData = function () {
            return _this.data;
        };
        /**
         * 根据语言和 key 获取对应的文字
         * @param lang Language Code
         * @param k key
         * @example lt('zh-CN', 'User.username');
         */
        this.lt = function (lang, k, options) {
            var value = _this.getValueByKey(k, lang);
            return value !== undefined && value !== ""
                ? _this.replace(value, options)
                : k;
        };
        /**
         * 根据 key 获取对应的文字
         * @param k key
         * @example t('User.username');
         */
        this.t = function (k, options) {
            var value = _this.getValueByKey(k);
            return value !== undefined && value !== ""
                ? _this.replace(value, options)
                : k;
        };
        /** 同步 i18n 文件, 使用方法 i18n.assign(LanguageCode['zh-CN'], {a: '123'}) */
        this.assign = function (lang, data) {
            if (_this.data[lang]) {
                Object.assign(_this.data[lang], data);
            }
            else {
                _this.data[lang] = data;
            }
        };
        this.data = data;
    }
    I18ner.prototype.getLanguage = function (language) {
        if (LanguageCode[language]) {
            return LanguageCode[language];
        }
        else if (this.data[language]) {
            return language;
        }
        else if (language.indexOf("en") > -1) {
            return LanguageCode.en;
        }
        else if (language.indexOf("vi") > -1) {
            return LanguageCode.vi;
        }
        else if (language.indexOf("zh") > -1) {
            return LanguageCode["zh-CN"];
        }
        return LanguageCode["zh-CN"];
    };
    I18ner.prototype.getValueByKey = function (k, languageCode) {
        var data = this.getData();
        var currentLangData = data[languageCode || this.languageCode];
        var tmpData = __assign({}, currentLangData);
        k.split(".").forEach(function (i) {
            if (tmpData) {
                tmpData = tmpData[i];
            }
        });
        return typeof tmpData === "string" ? tmpData.trim() : undefined;
    };
    I18ner.prototype.replace = function (value, options) {
        if (options) {
            if (Array.isArray(options)) {
                return value.replace(/\{(\d{1,2})\}/g, function (variable, second) {
                    return ((options[+second] !== undefined ? options[+second] : variable) +
                        "");
                });
            }
            return value.replace(/\$\{(.+?)\}/g, function (variable, key) {
                return options[key] !== undefined ? options[key] : variable;
            });
        }
        return value;
    };
    return I18ner;
}());
export default I18ner;
export var i18n = new I18ner({});
